// extracted by mini-css-extract-plugin
export default {"imageWrapper":"qE-z","hovered":"rE-z","hoverImage":"sE-z","mainImage":"tE-z","imageNoBackground":"uE-z","fullSizeImage":"vE-z"};